import React from "react";

import { COMPANY_RESEARCH_KNOWLEDGE_AUTO_REGISTRATION_NOTE } from "../lib/companyResearch";

export function CompanyResearchKnowledgeNotice() {
  return (
    <aside
      aria-label="ナレッジライブラリへの自動追加について"
      className="rounded-2xl border border-[#EADBC8] bg-[#FFF8F1] px-4 py-3 text-xs leading-5 text-[#7B6861]"
    >
      {COMPANY_RESEARCH_KNOWLEDGE_AUTO_REGISTRATION_NOTE}
    </aside>
  );
}
